import {
  CheckCircle2,
  Target,
  TrendingUp,
  Calendar,
  MessageSquare,
} from "lucide-react";

export default function SolutionSection() {
  const steps = [
    {
      icon: CheckCircle2,
      title: "Assess your life",
      description:
        "Take a short but powerful diagnostic based on the LIFE framework. You'll see where you're thriving and where you're stuck—clearly, measurably.",
    },
    {
      icon: Target,
      title: "Spot the real problem",
      description:
        "We connect to your calendar, health data, and patterns to uncover why you're stuck. It's not always what you think.",
    },
    {
      icon: TrendingUp,
      title: "Focus where it matters most",
      description:
        "We help you prioritize. Instead of doing everything at once, 1440 guides you to the highest-leverage area of your life, first.",
    },
    {
      icon: MessageSquare,
      title: "Take action daily",
      description:
        "You'll get small, highly personalized steps—delivered through the modalities that fit your day: text, voice, calls, data-based nudges.",
    },
    {
      icon: Calendar,
      title: "Track your progress",
      description:
        "You'll watch your LIFE score improve over time, through regular reassessments and clear feedback loops.",
    },
  ];

  return (
    <section className="py-24 md:py-32 bg-background">
      <div className="container mx-auto px-4 md:px-8 xl:px-12">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center space-y-12 mb-20">
            <div className="space-y-6">
              <span className="text-primary text-sm font-bold tracking-wider uppercase">
                HOW IT WORKS
              </span>
              <h2 className="text-3xl md:text-5xl xl:text-6xl font-bold md:font-extrabold leading-[0.9] tracking-tighter text-foreground max-w-4xl mx-auto">
                How 1440 works <span className="text-primary">for you:</span>
              </h2>
            </div>
            <div className="w-24 h-1 bg-primary mx-auto"></div>
          </div>

          {/* Steps grid */}
          <div className="space-y-8">
            {steps.map((step, index) => (
              <div key={index} className="group">
                <div className="grid lg:grid-cols-12 gap-8 items-start">
                  {/* Step number */}
                  <div className="lg:col-span-1">
                    <div className="w-16 h-16 border-2 border-primary bg-background flex items-center justify-center group-hover:bg-primary transition-colors">
                      <span className="text-2xl font-black text-primary group-hover:!text-black">
                        {(index + 1).toString().padStart(2, "0")}
                      </span>
                    </div>
                  </div>

                  {/* Icon */}
                  <div className="lg:col-span-2">
                    <div className="w-20 h-20 border-2 border-border bg-card flex items-center justify-center group-hover:border-primary group-hover:shadow-brutal group-hover:translate-x-1 group-hover:translate-y-1 transition-spring">
                      <step.icon className="w-10 h-10 text-foreground" />
                    </div>
                  </div>

                  {/* Content */}
                  <div className="lg:col-span-9 space-y-4">
                    <h3 className="text-3xl xl:text-4xl font-black text-foreground">
                      {step.title}
                    </h3>
                    <p className="text-xl text-muted-foreground leading-relaxed max-w-3xl">
                      {step.description}
                    </p>
                  </div>
                </div>

                {/* Divider */}
                {index < steps.length - 1 && (
                  <div className="w-full h-px bg-border my-12"></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
